import { render } from "./Navigator.vue?vue&type=template&id=2435c8ec&scoped=true&ts=true"
import script from "./Navigator.vue?vue&type=script&lang=ts"
export * from "./Navigator.vue?vue&type=script&lang=ts"

import "./Navigator.vue?vue&type=style&index=0&id=2435c8ec&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2435c8ec"]])

export default __exports__